/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".statement[_ngcontent-%COMP%]{margin-top:10px;font-style:italic}@media (min-width:768px){.party.info-item[_ngcontent-%COMP%]{height:18px;padding:2px 0;margin-bottom:10px}}.profile-detail-label[_ngcontent-%COMP%]{font-weight:500}"];
export { styles as styles };
